module.exports = __webpack_public_path__ + "static/img/pic-cnt-active-1.6c8b891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/en/pic-cnt-active-1.png
// module id = 1rWH
// module chunks = 0